import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useOnlineStatus } from './useOnlineStatus.js';
const containerStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4em',
    font: 'inherit',
    fontSize: '0.875rem',
    lineHeight: 1.2,
};
const dotBaseStyle = {
    width: '0.6em',
    height: '0.6em',
    borderRadius: '50%',
    flex: '0 0 auto',
};
/**
 * Renders the current connectivity state. When `online` is omitted it tracks
 * {@link useOnlineStatus}; passing `online` lets a parent drive it explicitly.
 */
export function ConnectivityIndicator({ online, onlineLabel = 'Online', offlineLabel = 'Offline', className, }) {
    const liveOnline = useOnlineStatus();
    const isOnline = online ?? liveOnline;
    const label = isOnline ? onlineLabel : offlineLabel;
    return (_jsxs("span", { role: "status", "aria-live": "polite", "data-online": isOnline, className: className, style: containerStyle, children: [_jsx("span", { "aria-hidden": "true", style: {
                    ...dotBaseStyle,
                    backgroundColor: isOnline ? '#1a7f37' : '#cf222e',
                } }), _jsx("span", { children: label })] }));
}
//# sourceMappingURL=ConnectivityIndicator.js.map